let resumeData = {
  "imagebaseurl":"https://ntethewonder.github.io/",
  "name": "Ntethelelo Shabalala",
  "role": "Software Developer",
  "linkedinId":"https://www.linkedin.com/in/ntethewonder/",
  "skypeid": "Your skypeid",
  "roleDescription": " a passionate someone with a flair for frontend development. Here, you'll discover the intersection of my academic journey, hands-on projects, and a deep-rooted love for crafting exceptional web solutions.",
  "socialLinks":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/in/ntethewonder/",
        "className":"fa fa-linkedin"
      },
      {
        "name":"github",
        "url":"http://github.com/ntethewonder",
        "className":"fa fa-github"
      },
      {
        "name":"skype",
        "url":"http://twitter.com/ntethewonder",
        "className":"fa fa-twitter"
      }
    ],
  "aboutme":"Hello! I'm Ntethelelo Shabalala, a recent graduate with a degree in Computer Science and Information Technology. Armed with proficiency in Java, Python, HTML, CSS, JavaScript and React, I'm eager to leverage my problem-solving mindset and collaborative spirit to contribute meaningfully to the tech industry. Adaptable and quick to learn, I bring a fresh perspective and enthusiasm for innovation. I'm actively seeking opportunities in software development, data analysis, or any exciting tech role where I can grow, learn, and make a positive impact. Let's connect and explore the possibilities together! 🚀 ntethewonder@gmail | https://www.linkedin.com/in/ntethewonder/",
  "address":"South Africa",
  "website":"https://ntethewonder.github.io",
  "education":[
    {
      "UniversityName":"BSc Computer Science and Information Technology",
      "specialization":"University of KwaZulu-Natal",
      "MonthOfPassing":"Dec",
      "YearOfPassing":"2021",
      "Achievements":"Some Achievements"
    },
    {
      "UniversityName":"Bhekathina High School",
      "specialization":"Science Stream",
      "MonthOfPassing":"Dec",
      "YearOfPassing":"2017",
      "Achievements":"Mathematics, Physical Science, Life Science, Geography, English (FAL), IsiZulu, LO"
    }
  ],
  "work":[
    {
      "CompanyName":"Some Company",
      "specialization":"Some specialization",
      "MonthOfLeaving":"Jan",
      "YearOfLeaving":"2018",
      "Achievements":"Some Achievements"
    },
    {
      "CompanyName":"The Complete 2023 Web development - bootcamp",
      "specialization":"Udemy",
      "MonthOfLeaving":"Oct",
      "YearOfLeaving":"2023",
      "Achievements":"Some Achievements"
    }
  ],
  "skillsDescription":"Your skills here",
  "skills":[
    {
      "skillname":"Java"
    },
    {
      "skillname":"Python"
    },
    {
      "skillname":"HTML5"
    },
    {
      "skillname":"CSS"
    },
    {
      "skillname":"Reactjs"
    }
  ],
  "portfolio":[
    {
      "name":"Web Design Agency",
      "description":"website for",
      "imgurl":"images/portfolio/coffee.jpg",
      "tools":"HTML, CSS and JavaScript",
      "gitLink":"https://ntethewonder.github.io",
      "webLink":"https://ntethewonder.github.io"
    },
    {
      "name":"E-commerce",
      "description":"mobileapp",
      "imgurl":"images/portfolio/girl.jpg",
      "tools":"JavaScript and ReactJS",
      "gitLink":"https://ntethewonder.github.io",
      "webLink":"https://ntethewonder.github.io"
    },
    {
      "name":"project3",
      "description":"mobileapp",  
      "imgurl":"images/portfolio/farmerboy.jpg",
      "tools":"JavaScript and ReactJS",
      "gitLink":"https://ntethewonder.github.io",
      "webLink":"https://ntethewonder.github.io"
    },
    {
      "name":"Portfolio Website",
      "description":"This is personal portfolio website built with React.js",
      "imgurl":"images/portfolio/judah.jpg",
      "tools":"JavaScript and ReactJS",
      "gitLink":"https://ntethewonder.github.io",
      "webLink":"https://ntethewonder.github.io"
    }
  ],
  "testimonials":[
    {
      "description":"This is a sample testimonial",
      "name":"Some technical guy"
    },
    {
      "description":"This is a sample testimonial",
      "name":"Some technical guy"
    }
  ]
}

export default resumeData